import { getStatusLabelKey } from './documentStatusChip';
import ColumnTextFilter from 'components/common/columnTextFilter';

import { DocStatus } from 'data/constants/DocStatus';
import useTranslate from 'hooks/useTranslate';

interface DocumentStatusFilterProps {
    value: string | null;
    onChange: (status: string | null) => void;
}

const DOCUMENT_STATUSES = Object.values(DocStatus);

const DocumentStatusFilter = ({ value, onChange }: DocumentStatusFilterProps) => {
    const { translate } = useTranslate();

    return (
        <ColumnTextFilter
            value={value ?? ''}
            onChange={(nextValue) => onChange(nextValue || null)}
            placeholder={translate('status')}
            ariaLabel={translate('filterByStatus')}
            options={DOCUMENT_STATUSES.map((status) => ({
                label: translate(getStatusLabelKey(status)),
                value: status,
            }))}
        />
    );
};

export default DocumentStatusFilter;
